import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { WORLDS } from "../data/worlds";

const statusStyle = {
  available: { bg: "#E4EEE7", color: "#356B45", dot: "#4A8B5D" },
  next: { bg: "#EEF4FC", color: "#2A5CA0", dot: "#3A7BD5" },
  planned: { bg: "#F3EDE2", color: "#7A746B", dot: "#A39B8E" },
};

export const WorldCard = ({ w, i }) => {
  const st = statusStyle[w.status];
  return (
    <Reveal delay={i * 0.1}>
      <Link
        to={`/lernwelten/${w.slug}`}
        className="card-soft p-6 flex flex-col h-full group transition-transform duration-500 hover:-translate-y-1.5 block"
        data-testid={`world-card-${w.slug}`}
      >
        <div className="relative rounded-[18px] overflow-hidden aspect-[4/3] mb-5" style={{ background: w.soft }}>
          {w.cover ? (
            <img src={w.cover} alt={`Cover ${w.title}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center gap-4">
              <div className="blob floaty-slow" style={{ background: `${w.accent}22`, width: "72%", height: "58%", top: "20%", left: "14%" }} />
              <span className="relative font-display italic font-semibold text-5xl" style={{ color: w.accent }}>
                {w.glyphs.join(" ")}
              </span>
              <span className="relative text-[10px] uppercase tracking-[0.24em] font-semibold" style={{ color: w.accent }}>
                Lernwelt {w.short}
              </span>
            </div>
          )}
        </div>
        <span
          className="inline-flex items-center gap-2 self-start text-[10px] uppercase tracking-[0.16em] font-semibold px-3 py-1.5 rounded-full mb-3"
          style={{ background: st.bg, color: st.color }}
          data-testid={`world-status-${w.slug}`}
        >
          <span className="w-1.5 h-1.5 rounded-full" style={{ background: st.dot }} />
          {w.statusLabel}
        </span>
        <h3 className="font-display text-xl font-medium leading-snug mb-1.5">{w.title}</h3>
        <p className="text-[13px] text-[color:var(--ink-muted)] leading-relaxed flex-1">{w.subtitle}</p>
        <span className="inline-flex items-center gap-1.5 text-[13px] font-semibold mt-4 transition-transform duration-300 group-hover:translate-x-1" style={{ color: "var(--terra)" }}>
          {w.status === "available" ? "Jetzt entdecken" : "Mehr erfahren"} <ArrowRight size={15} />
        </span>
      </Link>
    </Reveal>
  );
};

export const Universe = () => (
  <section className="py-24 sm:py-32" data-testid="universe-section">
    <div className="max-w-6xl mx-auto px-5 lg:px-8">
      <Reveal className="mb-14 max-w-2xl">
        <p className="eyebrow-label mb-5">Das VisualMA Universum</p>
        <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl leading-[1.08] mb-5">
          Eine Lernwelt ist erst<br />der <em style={{ color: "var(--terra)" }}>Anfang.</em>
        </h2>
        <p className="text-[15px] sm:text-base text-[color:var(--ink-muted)] leading-relaxed">
          Jede Lernwelt verbindet ein eigenes Buch mit einem eigenen Lernsong.{" "}
          <span className="font-medium text-[color:var(--ink)]">VisualMA wächst Lernwelt für Lernwelt weiter.</span>
        </p>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {WORLDS.map((w, i) => (
          <WorldCard key={w.slug} w={w} i={i} />
        ))}
      </div>
    </div>
  </section>
);
